export const MEMBERSHIP_PURCHASE_PROCESS_TYPES = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};
